export const SINGLE_CELLS = '@/SINGLE_CELLS';
export const SELECTION_TOOL = '@/SELECTION_TOOL';
